import { ReactElement, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useWizardSelector } from '@/components/ui/wizard/WizardState'
import WizardInputPlaceHolder, {
  WizardInputIcon,
  WizardInputProps,
} from '@/components/ui/wizard/WizardInputPlaceHolder'
import { setActiveStep } from '@/components/ui/wizard/WizardActions'

export default function WizardInput(props: WizardInputProps): ReactElement {
  const [hasFocus, setHasFocus] = useState(false)
  const dispatch = useDispatch()
  const activeStep = useWizardSelector<number | undefined>((s) => s.activeStep)

  function focused(): void {
    dispatch(setActiveStep(props.step))
    setHasFocus(true)
  }

  function blured(): void {
    setHasFocus(false)
  }

  function currentlyActive(): boolean {
    return activeStep === props.step
  }

  function icon(): WizardInputIcon | undefined {
    if (currentlyActive()) {
      return !props.searchTerm || !props.setSearchTerm
        ? WizardInputIcon.CHEVRON_DOWN
        : WizardInputIcon.DELETE
    } else {
      return props.selectedValues ? WizardInputIcon.DELETE : WizardInputIcon.CHEVRON_DOWN
    }
  }

  function close(): void {
    dispatch(setActiveStep(undefined))
  }

  function search(term: string): void {
    if (props.setSearchTerm) {
      dispatch(props.setSearchTerm(term))
    }
  }

  function resetOrClear(): void {
    dispatch(props.resetInput())
  }

  return (
    <WizardInputPlaceHolder
      {...props}
      focused={focused}
      blured={blured}
      icon={icon()}
      currentlyActive={currentlyActive()}
      hasFocus={hasFocus}
      activeStep={activeStep}
      close={close}
      search={search}
      resetOrClear={resetOrClear}
      scrollIntoViewOnLoad={props.scrollIntoViewOnLoad}
      searchWizard={props.searchWizard}
      highlighted={props.highlighted && !currentlyActive()}
      searchPage={props.searchPage}
    />
  )
}
